/**
 * Last-resort recoverable UI when React bootstrap fails.
 * Works without design-system CSS so offline / chunk failures still paint.
 *
 * @param {unknown} err
 * @param {{ kind?: string }} [options]
 */
export function paintStartupFailure(err, options = {}) {
  const root = document.getElementById("root");
  if (!root) return;

  const offline =
    typeof navigator !== "undefined" && navigator.onLine === false;
  const kind = options.kind || (offline ? "offline" : "error");

  // Prefer the inline HTML recovery (no flash of empty root)
  if (typeof window !== "undefined" && typeof window.__TRA_SHOW_STARTUP_RECOVERY__ === "function") {
    window.__TRA_SHOW_STARTUP_RECOVERY__(kind, err);
    return;
  }

  console.error("[TheRallyAlly bootstrap]", err);
  root.setAttribute("data-startup-recovery", kind);
  const title = offline ? "You’re offline" : "Couldn’t start TheRallyAlly";
  const body = offline
    ? "Reconnect, then try again. Cached pages work when the app is already open."
    : "Something went wrong while loading. Check your connection, then retry.";
  root.innerHTML = `<div data-testid="startup-failure" style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;box-sizing:border-box;font-family:system-ui,sans-serif;background:#fafaf8;color:#121212;text-align:center"><div><h1 style="font-size:18px;margin:0 0 8px">${title}</h1><p style="margin:0 0 16px;opacity:.72;font-size:14px;line-height:1.4;max-width:28rem">${body}</p><button type="button" onclick="location.reload()" style="min-height:48px;padding:0 20px;border:0;border-radius:999px;background:#12b76a;color:#fff;font-weight:600;font-size:14px;cursor:pointer">Try again</button></div></div>`;
}

/** Mark successful React mount so the HTML boot timer does not escalate. */
export function markAppMounted() {
  if (typeof window === "undefined") return;
  window.__TRA_APP_MOUNTED__ = true;
  if (typeof window.__TRA_CLEAR_BOOT_TIMER__ === "function") {
    window.__TRA_CLEAR_BOOT_TIMER__();
  }
  try {
    sessionStorage.removeItem("tra_boot_online_reloaded");
  } catch {
    /* ignore */
  }
}
